import { NgModule } from '@angular/core';

import { AuthGuard } from '../guards/auth.guard'
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { PagesComponent } from './pages.component';
import { PerfilComponent } from './perfil/perfil.component';
//Proceso
import { ProcesoComponent } from './proceso/proceso.component'
import { SimularComponent } from './proceso/simular/simular.component';
import { PagoComponent } from './proceso/pago/pago.component'
import { DocumentosComponent } from './proceso/documentos/documentos.component'
import { BorradorComponent } from './proceso/borrador/borrador.component'

const routes: Routes = [

    {
        path: '',
        component: PagesComponent,
        canActivate: [AuthGuard],
        children:
            [
                { path: 'inicio', component: MainComponent },
                { path: 'perfil', component: PerfilComponent },
                { path: 'proceso', component: ProcesoComponent },
                { path: 'proceso/:id', component: ProcesoComponent },
                { path: 'simular', component: SimularComponent },
                { path: 'pago', component: PagoComponent },
                { path: 'documentos', component: DocumentosComponent },
                { path: 'borrador', component: BorradorComponent },
                { path: '', redirectTo: '/inicio', pathMatch: 'full' },
            ]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
